export async function checkMicPermissions() {
  try {
    console.log('Comprobar permiso de micrófono');
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    // Solo se pide el permiso: Azure abre su propia captura del micrófono.
    stream.getTracks().forEach((track) => track.stop());
  } catch (error) {
    console.error('Err Permiso de micrófono', error);
  }
}
